import React from 'react'
import { useForm } from 'react-hook-form';

export default function MenuSearch() {
    const { register, handleSubmit } = useForm();
    const onSubmit = async data => {
        // console.log('data', data);
    }
    return (
        <div>
            <form onSubmit={handleSubmit((data) => onSubmit(data))}>
                <div className='relative'>
                    <input type="text" className='search-input-field' {...register('search')} placeholder="Search Question...." />
                    <img src={`/images/icons/search.svg`} alt="search" className='absolute top-2 left-3' />
                </div>

            </form>
        </div>
    )
}
